module.exports = __webpack_public_path__ + "img/step3.9648e0a1.png";